import { Directive } from '@angular/core';

@Directive({
    selector: '[dmpDTTEditableColumn]',
    standalone: false
})
export class DTTEditableColumnDirective {

  constructor() { }

}
